import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import { typography } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';

var defaultStyles = {
  color: "deal",
  fontFamily: "normal",
  fontSize: "12px",
  lineHeight: "1"
};
var ErrorMessage = /*#__PURE__*/styled("p").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "FieldErrorMessage__ErrorMessage",
  componentId: "sc-1x1vpz7-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  ", ";\n"], ["\n  margin: 0;\n  ", ";\n"])), typography);
var FieldErrorMessage = function (_a) {
  var message = _a.message,
    rest = __rest(_a, ["message"]);
  return React__default.createElement(ErrorMessage, __assign({}, defaultStyles, rest), message);
};
var templateObject_1;

export { ErrorMessage, FieldErrorMessage };
//# sourceMappingURL=FieldErrorMessage.js.map
